import { configureStore } from '@reduxjs/toolkit';

import commonRecuder from './common/reducer';
import staffReducer from './staff/reducer';
import gamesReducer from './games/reducer';
import playersReducer from './players/reducer';
import contactReducer from './contact/reducer';
import videoReducer from './videos';
import scheduleReducer from './schedule/reducer';
import memoryReducer from './memory/reducer';

export const createStore = () => configureStore({
    reducer: {
        common: commonRecuder,
        staff: staffReducer,
        games: gamesReducer,
        players: playersReducer,
        contact: contactReducer,
        videos: videoReducer,
        schedule: scheduleReducer,
        memory: memoryReducer
    }
});

export const store = createStore();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
